import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Estado',
      fields: {
        delivery_visible: {
          label: 'Entrega visible',
        },
        has_delivery: {
          label: 'Entrega',
        },
        delivery_enabled: {
          label: 'Entrega en vivo',
        },
      },
    },
    delivery_mode: {
      title: 'Modo de entrega',
      fields: {
        delivery_mode: {
          options: {
            [DeliveryMode.Internal]: 'Flota de repartidores del restaurante',
            [DeliveryMode.External]: 'Flota de repartidores externos ({{providers}})',
          },
        },
        external_delivery_pickup_note: {
          label: 'Nota de recogida para el repartidor',
          placeholder: 'Información adicional de recogida para el repartidor (p. ej., cómo encontrar la entrada, etc.)',
        },
        instant_print_enabled: {
          label: 'Imprimir ticket sin esperar al repartidor',
        },
        provider_not_connected: {
          wolt_drive: 'Aún no conectado: este restaurante no tiene un ID de local de Wolt válido.',
          connects_on_external:
            '{{provider}} se conecta cuando el modo de entrega se establece en repartidores externos y se guarda.',
          not_connected_yet:
            '{{provider}} aún no está conectado para este restaurante. Si esto no cambia, contacta con soporte.',
        },
      },
    },
    scheduled_orders: {
      title: 'Pedidos programados',
      fields: {
        has_scheduled_orders: {
          label: '¿Permite a sus clientes hacer pedidos con antelación para horarios específicos?',
        },
        min_schedule_ahead_time_delivery: {
          label: 'Tiempo mínimo (minutos) de antelación para programar pedidos de <strong>entrega</strong>',
          placeholder: '60',
          validation_name: 'Tiempo mínimo de programación de entrega',
          external_hint: 'Con entrega externa, debe ser al menos {{minutes}} minutos (2 horas). ',
        },
        last_order_gap_delivery: {
          label: 'Último momento para pedir <strong>entrega</strong> (minutos antes del cierre)',
          option: '{{value}} min',
        },
      },
    },
    delivery_info: {
      title: 'Información de entrega',
      fields: {
        average_order_delivery_time_min: {
          label: 'Tiempo de entrega',
          placeholder: 'Tiempo en minutos',
        },
        average_order_delivery_time_max: {
          label: 'hasta',
          placeholder: 'Opcional',
        },
      },
    },
    delivery_zones: {
      title: 'Zonas de entrega',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    at_least_one_order_method_required:
      'Al menos 1 método de pedido (programado o inmediato) debe estar activado. No se pueden desactivar ambos.',
  },
};
